import React, { Fragment, useEffect, useState } from "react";
import { Row, Col, Card, Badge, Dropdown } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import DataTable from "react-data-table-component";
import { DELETE, GET } from "../../../services/AxiosService";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";

const PesananBuku = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { start, end } = location.state || {}; // Use a default empty object in case state is undefined
  const [selectedRows, setSelectedRows] = useState([]);
  const [data, setData] = useState([]);
  const [tipePelajar, setTipePelajar] = useState([]);
  const [buku, setBuku] = useState([]);
  const [statusPesanan, setStatusPesanan] = useState([]);
  const [kota, setKota] = useState([]);
  const [selectedKota, setSelectedKota] = useState("");

  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedJudul, setSelectedJudul] = useState("");
  const [selectedTipePelajar, setSelectedTipePelajar] = useState("");
  const [selectedStatusPesanan, setSelectedStatusPesanan] = useState("");
  const [selectedTipePesanan, setSelectedTipePesanan] = useState("");
  const [selectedTipeBayar, setSelectedTipeBayar] = useState("");
  const [tipePesanan, setTipePesanan] = useState("");
  const [meta, setMeta] = useState("");
  const [status, setStatus] = useState("");
  const [isUniformStatus, setIsUniformStatus] = React.useState(false);
  const [dateFrom, setDateFrom] = useState(start);
  const [dateTo, setDateTo] = useState(end);
  const [internalDateTo, setInternalDateTo] = useState(null);
  const [kotaSearchTerm, setKotaSearchTerm] = useState("");
  const DropDownTipeBayar = [
    {
      id: 0,
      description: "Gratis",
      name: "Gratis",
    },
    {
      id: 1,
      description: "Berbayar",
      name: "Berbayar",
    },
  ];

  const permissions = JSON.parse(localStorage.getItem("ORDER_BOOK") || "[]");
  const canModify = permissions.some((permission) => ["VIEW", "UPDATE", "DELETE"].includes(permission));

  const fetchData = async (page, perPage, sortField, sortOrder, search, buku, tipePelajar, statusPesanan, dateFrom, dateTo, kotaKabupaten, tipePesanan, tipeBayar) => {
    const params = {
      page,
      size: perPage,
      sort: sortField,
      orderby: sortOrder,
      search,
      heading: buku,
      type: tipePelajar,
      status: statusPesanan,
      city: kotaKabupaten,
      start_date: dateFrom,
      end_date: internalDateTo,
      booking_type: tipePesanan,
      purchase_type: tipeBayar,
      purchase_type: tipeBayar,

    };
    const res = await GET(`/book-ordering`, params);
    console.log('fetch data');
    setData(res?.data);
    setMeta(res?.meta);
    setTotalRows(res?.meta?.amount);
  };

  const fetchTipePelajar = async () => {
    const res = await GET(`/master-data/type?type=tipe pelajar`);
    setTipePelajar(res?.data);
  };
  const fetchTipePesanan = async () => {
    const res = await GET(`/master-data/type?type=tipe%20pesanan`);
    console.log("ombak", res);
    setTipePesanan(res?.data);
  };
  const fetchBuku = async () => {
    const res = await GET(`/book?size=-1`);
    setBuku(res?.data);
  };
  const fetchStatusPesanan = async () => {
    const res = await GET(`/master-data/type?type=Status Pesanan Buku`);
    setStatusPesanan(res?.data);
  };
  const fetchKotaKabupaten = async (search = "") => {
    const params = {
      size: -1,
      search: search,
    };
    const res = await GET(`district`, params);
    setKota(res?.data || []); // Use empty array as a fallback
  };

  useEffect(() => {
    // Set up a timer
    const delayDebounceFn = setTimeout(() => {
      // Fetch data only after the user stops typing for 500ms
      fetchKotaKabupaten(kotaSearchTerm);
    }, 500);

    // Clear the timer if the user types again before 500ms has passed
    return () => clearTimeout(delayDebounceFn);
  }, [kotaSearchTerm]); // Only re-run the effect if kotaSearchTerm changes

  const fetchServerData = () => {
    fetchData(currentPage, perPage, sortField, sortOrder, searchTerm, selectedJudul, selectedTipePelajar, selectedStatusPesanan, dateFrom, dateTo, selectedKota, selectedTipePesanan, selectedTipeBayar);
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handlePerPageChange = (newPerPage) => {
    setPerPage(newPerPage);
    setResetPaginationToggle(!resetPaginationToggle);
  };
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    localStorage.setItem("searchTerm", e.target.value);
    setCurrentPage(1);

  };
  const handleSort = (column, direction) => {
    setSortField(column.field);
    setSortOrder(direction);
  };
  const handleDateFromChange = (date) => {
    const formattedDate = date?.toLocaleDateString("en-CA");
    setDateFrom(formattedDate);
    setDateTo(null);
    setInternalDateTo(null);
    setCurrentPage(1);
    setResetPaginationToggle(prev => !prev);
  };
  const handleDateToChange = (date) => {
    const formattedDate = date?.toLocaleDateString("en-CA");
    setDateTo(formattedDate);

    if (date) {
      // Menambahkan 1 hari secara internal untuk keperluan filter
      const nextDay = new Date(date);
      nextDay.setDate(nextDay.getDate() + 1);
      const formattedNextDay = nextDay.toLocaleDateString("en-CA");
      setInternalDateTo(formattedNextDay); // Set tanggal +1 hari secara internal
    } else {
      setInternalDateTo(null);
    }
    setCurrentPage(1);
    setResetPaginationToggle(prev => !prev);
  };
  const DatePickerWithClearIcon = ({ value, onChange, placeholderText }) => {
    return (
      <div
        className="datepicker-wrapper"
        style={{ position: "relative", display: "inline-block", paddingRight: "10px" }}
      >
        <DatePicker
          className="form-control datepicker-custom"
          value={value || ""}
          onChange={onChange}
          dateFormat="yyyy-MM-dd"
          placeholderText={placeholderText}
        />
        {value && (
          <i
            className="fa fa-times"
            onClick={() => onChange(null)}
            style={{
              position: "absolute",
              right: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "#aaa",
            }}
          />
        )}
      </div>
    );
  };

  const handleDeleteClick = async (id) => {
    const result = await Swal.fire({
      title: "Yakin ingin hapus data?",
      text: "Data yang dihapus tidak dapat dikembalikan!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ya",
      cancelButtonText: "Batal",
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const res = await DELETE(`/book-ordering/${id}`);
      if (res) {
        fetchServerData();
        Swal.fire({
          icon: "success",
          title: "Berhasil menghapus Pesanan Buku!",
        }).then(() => {
          Swal.close();
        });
      }
    }
  };
  
  // console.log("ini yaa", dateFrom, dateTo);

  useEffect(() => {
    fetchTipePelajar();
    fetchBuku();
    fetchStatusPesanan();
    fetchKotaKabupaten();
    fetchTipePesanan();
  }, []);

  useEffect(() => {
    fetchServerData();
  }, [perPage, searchTerm, currentPage, sortField, sortOrder, selectedJudul, selectedTipePelajar, selectedStatusPesanan, dateFrom, dateTo, selectedKota, selectedTipePesanan, selectedTipeBayar]);

  function currencyFormat(num) {
    num = parseFloat(num);
    return num
      .toFixed(2)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      .replace(/\.00$/, "");
  }

  const columns = [
    {
      name: "No Pesanan",
      selector: (row) => row.no,
      sortable: true,
      field: "no",
      cell: row => (
        <span style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>
          {row.no}
        </span>
      ),
    },
    {
      name: "Judul",
      selector: (row) => row.book_name,
      sortable: true,
      field: "book_name",
    },
    {
      name: "Nama Pelajar",
      selector: (row) => row.user?.name,
      sortable: true,
      field: "student_name",
      cell: (row) => (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            navigate(`/${row.students[0]?.id}/form-pelajar/Detail`, {
              state: { from: "Detail" },
            });
          }}
          style={{
            color: "#0C718C",
            textDecoration: "underline",
            background: "transparent",
            border: "none",
            cursor: "pointer",
            whiteSpace: "normal",
            wordBreak: "break-word",
          }}
        >
          {row.user?.name}
        </a>
      ),
    },
    {
      name: "Tipe Pelajar",
      selector: (row) => row.students?.type_user,
      sortable: true,
      field: "student_type",
      cell: (row) => <div>{row.students[0]?.type_user}</div>,
    },
    {
      name: "Tipe Pesanan",
      selector: (row) => row.type_orders?.name,
      sortable: true,
      field: "order_type",
    },
    {
      name: "Tujuan Pengiriman",
      selector: (row) => row.students?.[0]?.delivery?.delivery_name || "Alamat tidak tersedia",
      sortable: true,
      field: "delivery_name",
    },
    {
      name: "Harga Buku (Rp)",
      selector: (row) => row.book_price,
      sortable: true,
      field: "book_price",
      cell: (row) => (
        <span style={{ textAlign: "right", width: "100%" }}>
          {currencyFormat(row.book_price)}
        </span>
      )
    },
    {
      name: "Estimasi Biaya Ongkir (Rp)",
      selector: (row) => row.estimasi,
      sortable: true,
      field: "estimasi",
      cell: (row) => (
        <span style={{ textAlign: "right", width: "100%" }}>
          {currencyFormat(row.estimasi)}
        </span>
      )
    },
    {
      name: "Biaya Ongkir (Rp)",
      selector: (row) => row.shipping_cost,
      sortable: true,
      field: "shipping_cost",
      cell: (row) => (
        <span style={{ textAlign: "right", width: "100%" }}>
          {currencyFormat(row.shipping_cost)}
        </span>
      )
    },
    {
      name: "Total yang Dibayar (Rp)",
      selector: (row) => row.total_payment,
      sortable: true,
      field: "total_payment",
      cell: (row) => (
        <span style={{ textAlign: "right", width: "100%" }}>
          {currencyFormat(row.total_payment)}
        </span>
      )
    },
    {
      name: "Ongkir Aktual (Rp)",
      selector: (row) => row.actual_shipingcost,
      sortable: true,
      field: "actual_shipping_cost",
      cell: (row) => (
        <span style={{ textAlign: "right", width: "100%" }}>
          {currencyFormat(row.actual_shipingcost)}
        </span>
      )
    },
    {
      name: "Jumlah",
      selector: (row) => row.book_qty,
      sortable: true,
      field: "book_qty",
      cell: (row) => (
        <span style={{ textAlign: "right", width: "100%" }}>{row.book_qty}</span>
      )
    },
    {
      name: "No Pesanan Percetakan",
      selector: (row) => row.print_order_no,
      sortable: true,
      field: "print_order_no",
      cell: (row) => (
        <span style={{ textAlign: "right", width: "100%" }}>{row.print_order_no}</span>
      )
    },
    {
      name: "Waktu Pesan",
      selector: (row) => row.created_at,
      sortable: true,
      field: "created_at",
      cell: (row) => {
        if (!row.created_at) return "-";
        const utcDate = new Date(row.created_at);
        const formattedDate = utcDate.toLocaleDateString("id-ID", {
          day: "2-digit",
          month: "long",
          year: "numeric",
        });
        const formattedTime = utcDate
          .toLocaleTimeString("id-ID", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          })
          .replace(":", ".");
        return `${formattedDate} ${formattedTime}`;
      }
    },
    {
      name: "Status Pesanan",
      selector: (row) => row.status?.name,
      width: "200px",
      cell: (row) => (
        <Badge as="a" variant="outline-success badge-rounded">
          {row.status?.name}
        </Badge>
      ),
    },
    ...(canModify
      ? [
        {
          name: "Aksi",
          selector: (row) => row.id,
          width: "130px",
          cell: (row) => (
            <div>
              {permissions.includes("VIEW") && (
                <button
                  className="btn btn-info shadow btn-xs sharp"
                  title="Detail"
                  onClick={() => navigate(`/${row.id}/form-pesanan-buku/Detail`)}
                >
                  <i className="fa fa-eye"></i>
                </button>
              )}
              {permissions.includes("DELETE") && (
                <Link
                  className="btn btn-danger shadow btn-xs sharp mx-1"
                  title="Hapus"
                  onClick={() => handleDeleteClick(row.order_id)}
                >
                  <i className="fa fa-trash"></i>
                </Link>
              )}
            </div>
          ),
        },
      ]
      : []),
  ];

  const customStyles = {
    headRow: {
      style: {
        backgroundColor: "#FCFCFD",
        fontSize: "14px",
        fontWeight: "bold",
        color: "black",
      },
    },
    rows: {
      style: {
        backgroundColor: "#FFFFFF",
        "&:nth-child(2n)": {
          backgroundColor: "#F3F0FD",
        },
      },
    },
    cells: {
      style: {
        alignItems: "flex-start", // This will align content to the top
        paddingTop: "8px",
        paddingBottom: "8px",
        wordBreak: "normal",

      },
    },
  };

  const handleRowSelected = (state) => {
    const selectStatus = state.selectedRows.map((row) => row.status.name);
    const selectedIds = state.selectedRows.map((row) => row.id);
    const isSameStatus = selectStatus.every((s) => s === selectStatus[0]);
    setSelectedRows(selectedIds);
    setStatus(selectStatus);
    setIsUniformStatus(isSameStatus);
  };

  const handleUbahPesananClick = () => {
    console.log("rows", selectedRows);
    if (selectedRows.length > 0) {
      navigate(`/${selectedRows}/form-pesanan-buku/Edit`, {
        state: { status, currentPage, dataParams: data },
      });
    }
  };

  const handleSelectTipePelajar = (e) => {
    setSelectedTipePelajar(e.target.getAttribute("value"));
    setCurrentPage(1);
    setResetPaginationToggle(prev => !prev); // <-- ADD THIS LINE

  };
  const handleSelectJudul = (e) => {
    setSelectedJudul(e.target.getAttribute("value"));
    setCurrentPage(1);
    setResetPaginationToggle(prev => !prev); // <-- ADD THIS LINE

  };
  const handleSelectStatusPesanan = (e) => {
    setSelectedStatusPesanan(e.target.getAttribute("value"));
    setCurrentPage(1);
    setResetPaginationToggle(prev => !prev); // <-- ADD THIS LINE

  };
  const handleSelectedTipePesan = (e) => {
    setSelectedTipePesanan(e.target.getAttribute("value"));
    setCurrentPage(1);
    setResetPaginationToggle(prev => !prev); // <-- ADD THIS LINE

  };
  const handleSelectedTipeBayar = (e) => {
    setSelectedTipeBayar(e.target.getAttribute("value"));
    setCurrentPage(1);
    setResetPaginationToggle(prev => !prev); // <-- ADD THIS LINE

  };
  const handleSelectKota = (e) => {
    setSelectedKota(e.target.getAttribute("value"));
    setCurrentPage(1);
    setResetPaginationToggle(prev => !prev); // <-- ADD THIS LINE
  };

  return (
    <Fragment>
      <Row>
        <Col lg={12}>
          <Card>
            <Card.Header>
              <Card.Title>Daftar Pesanan Buku</Card.Title>
            </Card.Header>
            <div className="d-flex flex-column flex-sm-row justify-content-between mt-4">
              <div className="d-flex flex-wrap pl-4 pr-1">
                <Dropdown className="mr-2 my-1">
                  <Dropdown.Toggle style={{ background: "transparent", borderColor: "grey", color: "grey", }} id="dropdown-basic">
                    {selectedJudul?.length > 0 ? selectedJudul : "Semua Judul"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item key="all" value="" onClick={handleSelectJudul}>
                      Semua Judul
                    </Dropdown.Item>
                    {Array.isArray(buku) &&
                      buku.map((bukus) => (
                        <Dropdown.Item key={bukus.id} value={bukus.name} onClick={handleSelectJudul}>
                          {bukus.name}
                        </Dropdown.Item>
                      ))}
                  </Dropdown.Menu>
                </Dropdown>

                <Dropdown className="mr-2 my-1">
                  <Dropdown.Toggle style={{ background: "transparent", borderColor: "grey", color: "grey" }} id="dropdown-basic">
                    {selectedTipeBayar?.length > 0 ? selectedTipeBayar : "Semua Tipe Bayar"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item key="all" value="" onClick={handleSelectedTipeBayar}>
                      Semua Tipe Bayar
                    </Dropdown.Item>
                    {Array.isArray(DropDownTipeBayar) &&
                      DropDownTipeBayar.map((pesananBayar) => (
                        <Dropdown.Item key={pesananBayar.id} value={pesananBayar.name} onClick={handleSelectedTipeBayar}>
                          {pesananBayar.name}
                        </Dropdown.Item>
                      ))}
                  </Dropdown.Menu>
                </Dropdown>

                <Dropdown className="mr-2 my-1">
                  <Dropdown.Toggle style={{ background: "transparent", borderColor: "grey", color: "grey", }} id="dropdown-basic">
                    {selectedTipePelajar?.length > 0 ? selectedTipePelajar : "Semua Tipe Pelajar"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item key="all" value="" onClick={handleSelectTipePelajar}>
                      Semua Tipe Pelajar
                    </Dropdown.Item>
                    {Array.isArray(tipePelajar) &&
                      tipePelajar.map((pelajarTipe) => (
                        <Dropdown.Item key={pelajarTipe.id} value={pelajarTipe.name} onClick={handleSelectTipePelajar}>
                          {pelajarTipe.name}
                        </Dropdown.Item>
                      ))}
                  </Dropdown.Menu>
                </Dropdown>
                <Dropdown className="mr-2 my-1">
                  <Dropdown.Toggle style={{ background: "transparent", borderColor: "grey", color: "grey", }} id="dropdown-basic">
                    {selectedStatusPesanan?.length > 0 ? selectedStatusPesanan : "Semua Status Pesanan"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="mr-2 my-1">
                    <Dropdown.Item key="all" value="" onClick={handleSelectStatusPesanan}>
                      Semua Status Pesanan
                    </Dropdown.Item>
                    {Array.isArray(statusPesanan) &&
                      statusPesanan.map((statusPesanans) => (
                        <Dropdown.Item key={statusPesanans.id} value={statusPesanans.name} onClick={handleSelectStatusPesanan}>
                          {statusPesanans.name}
                        </Dropdown.Item>
                      ))}
                  </Dropdown.Menu>
                </Dropdown>
                <Dropdown className="mr-2 my-1">
                  <Dropdown.Toggle style={{ background: "transparent", borderColor: "grey", color: "grey", }} id="dropdown-basic">
                    {selectedKota?.length > 0 ? selectedKota : "Semua Kota/Kabupaten"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu
                    style={{
                      maxHeight: "300px", // Set the maximum height of the dropdown
                      overflowY: "auto", // Enable vertical scrolling
                    }}
                  >

                     <div className="px-2 py-1">
                      <input
                        autoFocus
                        className="form-control"
                        placeholder="Cari kota/kabupaten..."
                        onChange={(e) => setKotaSearchTerm(e.target.value)}
                        value={kotaSearchTerm}
                      />
                    </div>
                    <Dropdown.Divider />

                    <Dropdown.Item key="all" value="" onClick={handleSelectKota}>
                      Semua Kota/Kabupaten
                    </Dropdown.Item>
                    {Array.isArray(kota) &&
                      kota.map((kotas) => (
                        <Dropdown.Item key={kotas.id} value={kotas.name} onClick={handleSelectKota}>
                          {kotas.name}
                        </Dropdown.Item>
                      ))}
                  </Dropdown.Menu>
                </Dropdown>

                <div className="d-flex ">
                  <div className="d-flex">
                    <DatePickerWithClearIcon value={dateFrom} onChange={handleDateFromChange} placeholderText="Waktu Pesan (from)" />
                    <DatePickerWithClearIcon value={dateTo} onChange={handleDateToChange} placeholderText="Waktu Pesan (to)" />
                  </div>
                </div>
              </div>

              {/* <div className="d-flex align-self-baseline px-4"> */}
              <div className="d-flex justify-content-end px-4 mt-1 flex-column flex-md-row">
                {/* <div style={{ maxHeigh}}> */}
                {/* <button className="btn btn-primary mr-2" onClick={handleUbahPesananClick} disabled={selectedRows.length === 0}> */}
                {permissions.includes("UPDATE") && (
                  <button
                    className="btn btn-primary mr-1 same-height"
                    style={{
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                      transition: "box-shadow 0.2s, transform 0.2s",
                      color: "white",
                      whiteSpace: "nowrap",
                      overflow: "visible",
                      textOverflow: "ellipsis" /* optional, in case it’s really too long */
                    }}
                    onClick={handleUbahPesananClick}
                    disabled={selectedRows.length === 0 || !isUniformStatus || status.some((s) => s === "Kedaluarsa" || s === "Menunggu Alokasi" || s === "Menunggu Pembayaran")}
                  >
                    Ubah Pesanan Buku
                  </button>
                )}
                {/* </div> */}
                <div className="input-group search-area d-xl-inline-flex">
                  <input type="text" className="form-control same-height" placeholder="Cari Buku" value={searchTerm} onChange={handleSearchChange} />
                  <div className="input-group-append">
                    <span className="input-group-text same-height">
                      <Link to="#">
                        <i className="flaticon-381-search-2" />
                      </Link>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <Card.Body>
              <p style={{ margin: "1px 0", fontWeight: "700" }}>Qty : {meta?.qty_total != null ? meta.qty_total : 0}</p>
              <p style={{ margin: "1px 0", fontWeight: "700" }}>Biaya : {meta?.amount_total != null ? new Intl.NumberFormat("id-ID").format(meta.amount_total) : 0}</p>
              {/* <p style={{ margin: "1px 0", fontWeight: "700" }}>Total Ongkir : {meta.total_shipping_cost ? new Intl.NumberFormat("id-ID").format(meta.total_shipping_cost) : 0}</p> */}
              <p style={{ margin: "1px 0", fontWeight: "700" }}>Total Ongkir Aktual : {meta.total_actual_shipingcost ? new Intl.NumberFormat("id-ID").format(meta.total_actual_shipingcost) : 0}</p>
              <p style={{ margin: "1px 0", fontWeight: "700" }}>Total Ongkir Estimasi : {meta.total_estimasi ? new Intl.NumberFormat("id-ID").format(meta.total_estimasi) : 0}</p>
              <p style={{ margin: "1px 0", fontWeight: "700" }}>Total Harga Buku : {meta.total_shipping_cost ? new Intl.NumberFormat("id-ID").format(meta.total_book_price) : 0}</p>

              {data && data.length > 0 ? (
                <DataTable
                  columns={columns}
                  data={data}
                  customStyles={customStyles}
                  selectableRows={permissions.includes("UPDATE")} // Conditionally show selectable rows
                  onSelectedRowsChange={handleRowSelected}
                  pagination
                  paginationServer
                  paginationRowsPerPageOptions={[10, 50, 100, 500]}
                  paginationResetDefaultPage={resetPaginationToggle}
                  paginationPerPage={perPage}
                  paginationTotalRows={totalRows}
                  onChangePage={handlePageChange}
                  onChangeRowsPerPage={handlePerPageChange}
                  onSort={handleSort}
                  sortServer
                />
              ) : (
                <p>Tidak ada data</p>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Fragment >
  );
};

export default PesananBuku;
